import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  inject,
  computed,
  Signal,
  Input,
  OnChanges,
  SimpleChanges,
  input,
} from "@angular/core";
import { Country } from "@bitwarden/web-vault/app/models/types/general-types";
import { DataPluginStoreService } from "@bitwarden/web-vault/app/services/store/data-plugin/data-plugin.store.service";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { AppStateStoreService } from "@bitwarden/web-vault/app/services/store/app-state/app-state.store.service";
import { CountryView } from "@bitwarden/web-vault/app/models/view/country/country.view";
import { panelRadiusTypes } from "@bitwarden/web-vault/app/components/dropdown/dropdown-select/dropdown-select.component";

@Component({
  selector: "app-countries",
  templateUrl: "./countries.component.html",
})
export class CountriesComponent {
  @Output() selectedCountry: EventEmitter<Country> = new EventEmitter<Country>();
  @Output() selectedCountries: EventEmitter<Country[]> = new EventEmitter<Country[]>();
  preSelected = input<Country>();
  // Render the dropdown panel in a CDK overlay so it escapes any clipping/scrolling
  // ancestor (e.g. the modal-body in the manually-add-institution flow).
  @Input() panelRadius: panelRadiusTypes = "default";
  @Input() detachPanel = false;

  protected appState: AppStateStoreService = inject(AppStateStoreService);
  dataPluginStoreService: DataPluginStoreService;
  constructor(private userStore: UserStoreService) {
    this.dataPluginStoreService = inject(DataPluginStoreService);
  }

  countries: Signal<CountryView[]> = computed((): CountryView[] => {
    const countries = this.dataPluginStoreService.theCountryList.theCountryViews() ?? [];
    if (this.appState.wizard().isVisible === true) {
      return countries.filter(
        (country) => country.code === this.userStore.preferences.preferenceView()?.userLocation,
      );
    } else {
      return countries;
    }
  });

  countryNames = computed(() => this.countries().map((country) => country.name));

  preselectedValue = computed(() => {
    if (this.preSelected()) {
      return this.preSelected().name;
    }

    if (this.appState.wizard().isVisible && this.countries().length > 0) {
      const country = this.countries()[0];
      this.selectedCountry.emit(country);
      return country.name;
    } else {
      return "";
    }
  });

  countrySelected(countryName: string) {
    const selectedCountry = this.countries().find((country) => country.name === countryName);
    if (selectedCountry) {
      this.selectedCountry.emit(selectedCountry);
    }
  }

  selectionCleared() {
    this.selectedCountry.emit(null);
  }
}
